import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  ogImage, 
  ogType = 'website',
  canonicalUrl,
  noIndex = false,
  structuredData
}) => {
  const defaultTitle = 'SPOTFLI - Find Your Perfect Stay';
  const defaultDescription = 'Discover the best hotels, guest houses, and properties for your perfect stay. Book accommodations with ease on SPOTFLI.';
  const defaultKeywords = 'hotel booking, accommodation, guest house, property rental, vacation rental, travel';
  
  const siteUrl = import.meta.env.VITE_FRONTEND_URL || 'https://www.spotfli.com';
  const finalTitle = title ? `${title} | SPOTFLI` : defaultTitle;
  const finalDescription = description || defaultDescription;
  const finalKeywords = keywords || defaultKeywords;
  const finalCanonical = canonicalUrl || siteUrl;
  const finalOgImage = ogImage
    ? ogImage.startsWith('http') ? ogImage : `${siteUrl}${ogImage}`
    : `${siteUrl}/og-image.jpg`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{finalTitle}</title>
      <meta name="description" content={finalDescription} />
      <meta name="keywords" content={finalKeywords} />
      
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      
      {/* Canonical URL */}
      <link rel="canonical" href={finalCanonical} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={finalCanonical} />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:image" content={finalOgImage} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={finalCanonical} />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDescription} />
      <meta name="twitter:image" content={finalOgImage} />
      
      {/* Additional SEO */}
      <meta name="language" content="English" />
      <meta name="theme-color" content="#2563eb" />
      
      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
